module.exports = __webpack_public_path__ + "img/symbol_8.63776ed1.png";